<template>
  <section
    class="component-de0817df"
    resmed-component-name="4card_icon-line_text_link"
    v-bind:style="{
      background: acf.layout['background'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div class="col">
            <div class="title">
              <h5 v-bind:class="[`text-color-${acf.layout['text-color']}`]">
                {{ acf.headline }}
              </h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="items">
              <div class="item" v-for="(item, index) in items">
                <a
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="card"
                  v-on:mouseover="mouseover(index)"
                >
                  <figure>
                    <img
                      v-if="['xs', 'sm', 'md', 'lg'].includes($root.mode)"
                      class="img-fluid"
                      v-bind:src="`@/assets/images/${item.svg}`"
                    />
                    <div v-else class="animation">
                      <animation
                        v-bind:play="item.play"
                        v-bind:autoplay="false"
                        v-bind:animation="JSON.parse(item.animation)"
                      ></animation>
                    </div>
                  </figure>

                  <div class="content">
                    <div class="mb-3 content-body">
                      <h5 v-html="item.title"></h5>
                      <p v-html="item.description"></p>
                    </div>

                    <div class="call-to-action">
                      <a
                        v-bind:href="item.cta.href"
                        v-bind:target="item.cta.target"
                        class="ctaButton cta-plain text-red icon right-arrow"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-de0817df", // 4card_icon-line_text_link (w/animations)
  props: ["acf"],
  data() {
    return {
      active: false,
      items: [],
    };
  },
  methods: {
    mouseover(index) {
      for (let value of this.items) {
        value.play = false;
      }

      this.$nextTick(() => {
        this.items[index].play = true;
      });
    },
  },
  created() {
    for (let value of this.acf.cards) {
      value.play = false; // add play property
    }

    this.items = Object.assign([], this.acf.cards);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.title {
  text-align: center;
  margin-bottom: 0.5rem;
  @extend %body-normal-bold;

  @media (min-width: 1200px) {
    text-align: left;
  }

  h5 {
    position: relative;
    margin-bottom: 0.25rem;
    color: $cc-resmed-white;

    &.text-color-black {
      color: $cc-resmed-black;

      &:before {
        background-color: $cc-resmed-black;
      }
    }

    @extend %eyebrow-left;
    &:before {
      background-color: $cc-resmed-white;

      @media (max-width: 1199px) {
        left: 50%;
        transform: translateX(-50%);
      }
    }

    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }
}

.component {
  padding: 4rem 0;

  .items {
    margin: 0 -0.625rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      padding: 0.625rem;

      @media (min-width: 768px) {
        width: calc(100% / 2);
      }

      @media (min-width: 992px) {
        max-width: 322px;
      }

      @media (min-width: 1200px) {
        width: calc(100% / 4);
      }

      .card {
        display: flex;
        flex-direction: column;
        color: inherit;

        background-color: $cc-resmed-white;
        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        padding: 2rem 1rem 2.5rem 1rem;

        max-width: 360px;
        transition: all 0.5s;
        cursor: pointer;
        height: 100%;

        &:hover {
          background-color: $cc-resmed-bg-grey-2;
        }

        @media (min-width: 768px) {
          max-width: none;
          min-height: 460px;
        }

        @media (min-width: 1200px) {
          min-height: 500px !important;
        }

        figure {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.625rem;

          .animation,
          .img-fluid {
            height: 224px;
            width: 100%;
            max-width: 224px;
          }

          .animation {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          svg {
            width: 224px !important;
            height: 224px !important;
          }
        }

        .content {
          padding: 0 0.5rem;
          text-align: center;

          @media (min-width: 768px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            text-align: left;

            padding: 0 0.25rem 0 0.75rem;

            .content-body {
              flex: 1 0 auto;
            }
          }

          h5 {
            margin-bottom: 0.75rem;
          }

          .call-to-action {
            align-self: flex-start;
          }
        }
      }
    }
  }
}
</style>